namespace TabAurous.OMS {
    export interface HsnTaxMasterForm {
        Code: Serenity.StringEditor;
        Type: Serenity.StringEditor;
        Description: Serenity.StringEditor;
        Details: HSNTaxDetailsEditor;
        TaxLedgerId: Serenity.IntegerEditor;
        Tax1LedgerId: Serenity.IntegerEditor;
        Tax2LedgerId: Serenity.IntegerEditor;
        CessLedgerId: Serenity.IntegerEditor;
        Cess1LedgerId: Serenity.IntegerEditor;
        Num1: Serenity.IntegerEditor;
        Num2: Serenity.DecimalEditor;
        Num3: Serenity.StringEditor;
        String1: Serenity.StringEditor;
        String2: Serenity.StringEditor;
        String3: Serenity.StringEditor;
        SysDate: Serenity.DateEditor;
    }

    export class HsnTaxMasterForm extends Serenity.PrefixedContext {
        static formKey = 'OMS.HsnTaxMaster';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!HsnTaxMasterForm.init)  {
                HsnTaxMasterForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = HSNTaxDetailsEditor;
                var w2 = s.IntegerEditor;
                var w3 = s.DecimalEditor;
                var w4 = s.DateEditor;

                Q.initFormType(HsnTaxMasterForm, [
                    'Code', w0,
                    'Type', w0,
                    'Description', w0,
                    'Details', w1,
                    'TaxLedgerId', w2,
                    'Tax1LedgerId', w2,
                    'Tax2LedgerId', w2,
                    'CessLedgerId', w2,
                    'Cess1LedgerId', w2,
                    'Num1', w2,
                    'Num2', w3,
                    'Num3', w0,
                    'String1', w0,
                    'String2', w0,
                    'String3', w0,
                    'SysDate', w4
                ]);
            }
        }
    }
}
